import { SETTINGS_LOADED } from '../actions/settings';

export default function(state = {}, action) {
  switch (action.type) {
    case SETTINGS_LOADED: {
      return {
        ...state,
        adminUrls: action.payload.adminUrls,
        caseUrls: action.payload.caseUrls,
        repairTicketCategories: action.payload.repairTicketCategories,
        repairTicketErrorCodes: action.payload.repairTicketErrorCodes,
        equityDeployMarkets: action.payload.equityDeployMarkets,
      };
    }
    default:
      return state;
  }
}
